import { HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService } from '@core/logging';
import { finalize, tap } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private logService: LogService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    const started = Date.now();
    let success = false;

    // extend server response observable with logging
    return next.handle(req).pipe(
      tap(event => {
        success = event instanceof HttpResponse;
      }),
      finalize(() => {
        const elapsed = Date.now() - started;
        const msg = `${req.method} "${req.urlWithParams}" ${
          success ? 'succeeded' : 'failed'
        } in ${elapsed} ms.`;
        if (success) {
          this.logService.info(msg);
        } else {
          this.logService.error(msg);
        }
      })
    );
  }
}
